import type { IncidentListSearch } from "../incidents/search";

/**
 * Drilldown search builders for the five KPI tiles (F-020 / AC-020): every
 * tile links to the FILTERED incident list. Pure and unit-tested; the page
 * passes the returned object as the TanStack Router `search` prop.
 */

/** The four non-resolved lifecycle states count as "open" (GR-001, F-020). */
export const OPEN_STATUSES = "neu,in_analyse,in_bearbeitung,beobachtet" as const;

/** ISO timestamp `days` days before `now` (default: the current time). */
export function isoDaysBefore(days: number, now: Date = new Date()): string {
  return new Date(now.getTime() - days * 86_400_000).toISOString();
}

/** Tile 1 "Offene Vorfälle"; a severity row narrows by its severityId. */
export function openIncidentsSearch(severityId?: string): IncidentListSearch {
  return {
    statuses: OPEN_STATUSES,
    ...(severityId ? { severityId } : {}),
  };
}

/** Tile 2, resolved without a postmortem (F-020): information since LP-030, not a gap. */
export function missingPostmortemSearch(): IncidentListSearch {
  return { missingPostmortem: true };
}

/** Tile 3 "Überfällige Follow-ups". */
export function overdueFollowupSearch(): IncidentListSearch {
  return { overdueFollowup: true };
}

/** Tile 4 "Letzte 7 Tage". */
export function last7DaysSearch(now?: Date): IncidentListSearch {
  return { createdAfter: isoDaysBefore(7, now) };
}

/**
 * Tile 5 "Letzte 30 Tage nach Kategorie". The tile itself links without a
 * category; a category row narrows by its id. A null categoryId (the "Ohne
 * Kategorie" row) cannot be expressed as a list filter and links unnarrowed.
 */
export function last30DaysCategorySearch(
  categoryId: string | null,
  now?: Date,
): IncidentListSearch {
  return {
    createdAfter: isoDaysBefore(30, now),
    ...(categoryId ? { categoryId } : {}),
  };
}
